import { Injectable, inject } from "@angular/core";
import { RisrExpandableField, RisrFormTypeExpander, RisrSchemaField } from "@fry-it/risr-core";
import { RelationStore } from "./relation-store";

@Injectable({
    providedIn: 'root'
})
export class RelationCategoryFieldExpander implements RisrFormTypeExpander {
    private readonly relationStore = inject(RelationStore);

    provideTypes: string[] = ['relation_category'];
    async expand(field: RisrExpandableField): Promise<RisrSchemaField> {

        const allowedRelations = field.extra?.relations;
        let relations;
        if (allowedRelations) {
            relations = await this.relationStore.getMany(allowedRelations);
        } else {
            relations = await this.relationStore.getAll();
        }

        const categories = relations
            .flatMap(relation => relation.flatCategories())
            .map(category => ({
                name: category._id,
                label: category.name
            }));

        return {
            name: field.id,
            label: field.label,
            type: 'discrete_multiple',
            required: field.required,
            options: {
                categories: [
                    { name: '__all__', label: 'All' },
                    ...categories,
                ],
            },
            initialValue: field.initialValue
        }
    }
}